import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

export const query = gql`
  mutation CreateUpcomingSuperchargerSubscriber(
    $gameId: Int!
    $hostId: Int!
    $email: String!
  ) {
    createUpcomingSuperchargerSubscriber(
      gameId: $gameId
      hostId: $hostId
      email: $email
    )
  }
`;

export function useCreateUpcomingSuperchargerSubscriber() {
  const [mutate, { loading, error }] = useMutation(query);

  const createUpcomingSuperchargerSubscriber = ({ gameId, hostId, email }) =>
    mutate({ variables: { gameId, hostId, email } });

  return { createUpcomingSuperchargerSubscriber, loading, error };
}
